import React, { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";
import { RocketIcon } from "@primer/octicons-react";
import Alert from "react-bootstrap/Alert";
import axios from "axios";
import ContentLoader from "react-content-loader";

import { REST_API } from "../../../services/constants";
import { seo } from "../../../components/seo.component";
import AuthService from "../../../services/auth.service.ts";
import authHeader from "../../../services/auth-header";
import TopicCard from "../../../components/topic-card.component";

import "./dashboard.scss";
import Swal from "sweetalert2";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

const TopicCardLoader = () => (
  <ContentLoader>
    <rect x="0" y="0" rx="5" ry="5" width="300" height="13" />
    <rect x="0" y="18" rx="4" ry="4" width="300" height="10" />
    <rect x="0" y="35" rx="3" ry="3" width="250" height="6" />
    <rect x="0" y="45" rx="3" ry="3" width="260" height="6" />
    <rect x="0" y="55" rx="3" ry="3" width="246" height="6" />
    <rect x="0" y="65" rx="3" ry="3" width="280" height="6" />
    <rect x="0" y="80" rx="4" ry="4" width="80" height="18" />
  </ContentLoader>
);

export default function AccountDashboardPage() {
  const history = useHistory();
  const [assignedTopics, setAssignedTopics] = useState(null);

  const updateAssignedTopics = async () => {
    axios({
      method: "GET",
      url: `${REST_API}/api/secure/topics/assigned/`,
      headers: await authHeader(),
    })
      .then((response) => {
        if (response.status === 200) {
          const sortedTopics = [...response.data].sort((a, b) => {
            return a.order_nr - b.order_nr;
          });
          console.log(sortedTopics);
          setAssignedTopics(sortedTopics);
        } else {
          Toast.fire({
            icon: "error",
            timer: false,
            title: "Verbindung fehlgeschlagen",
          });
        }
      })
      .catch((err) => {
        console.warn(
          `Received ${err?.response?.status} as status code. User needs to be logged out.`,
        );
        //AuthService.logout();
        //history.push('/');

        if (err?.response?.status !== 401) {
          Toast.fire({
            icon: "error",
            timer: false,
            title: "Verbindung fehlgeschlagen",
          });
        }
      });
  };

  useEffect(() => {
    seo({ title: "Campboard • Dashboard" });
    updateAssignedTopics();
  }, []);

  return (
    <div>
      <h2 className="mb-3">Obligatorische Themen</h2>
      <div className="dashboard-topics">
        {!assignedTopics ? (
          <>
            <TopicCardLoader />
            <TopicCardLoader />
            <TopicCardLoader />
            <TopicCardLoader />
          </>
        ) : assignedTopics.filter((item) => item.mandatory).length === 0 ? (
          <Alert variant="info" style={{ margin: 15 }}>
            <RocketIcon className="mr-3" /> Dir wurden keine Themen zugewiesen.
            Schaue später wieder vorbei.
          </Alert>
        ) : (
          assignedTopics
            .filter((item) => item.mandatory)
            .map((filteredItem, index) => (
              <TopicCard
                key={index}
                id={filteredItem.id}
                title={filteredItem.title}
                info={filteredItem.info}
                progress={filteredItem.percentDone * 100}
                taskCount={filteredItem.taskCount}
                finishedTasks={filteredItem.finishedTasks}
              />
            ))
        )}
      </div>

      <br />

      <h2 className="mb-3 mt-5">Optionale Themen</h2>
      <div className="dashboard-topics">
        {!assignedTopics ? (
          <>
            <TopicCardLoader />
            <TopicCardLoader />
            <TopicCardLoader />
          </>
        ) : assignedTopics.filter((item) => !item.mandatory).length === 0 ? (
          <Alert variant="info" style={{ margin: 15 }}>
            <RocketIcon className="mr-3" /> Dir wurden keine optionale Themen
            zugewiesen. Schaue später wieder vorbei.
            <br />
            <p style={{ opacity: 0.5 }} className="mt-3 mb-0">
              Optionale Themen sind nicht obligatorisch. Löse sie wenn du Zeit
              hast.
            </p>
          </Alert>
        ) : (
          assignedTopics
            .filter((item) => !item.mandatory)
            .map((filteredItem, index) => (
              <TopicCard
                key={index}
                id={filteredItem.id}
                title={filteredItem.title}
                info={filteredItem.info}
                progress={filteredItem.percentDone * 100}
                taskCount={filteredItem.taskCount}
                finishedTasks={filteredItem.finishedTasks}
              />
            ))
        )}
      </div>
    </div>
  );
}
